<template>
    <div class="login ">
      <div class="container ">
        <div class="row align-items-center">
          <div class="col-md-6 align-middle py-5 ">
            <h1 class="laranja">{{$t('login.login')}}</h1>
            <p>{{$t('login.descricao')}}</p>
            <form class="mt-5 col-md-10" @submit.prevent="submit">
              <div class="mb-3 d-flex">
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="loginTypeUsername" value="username" v-model="loginType">
                  <label class="form-check-label" for="loginTypeUsername">{{ $t('login.username') }}</label>
                </div>
                <div class="form-check form-check-inline">
                  <input class="form-check-input" type="radio" id="loginTypePhone" value="phone" v-model="loginType">
                  <label class="form-check-label" for="loginTypePhone">{{ $t('label.tel') }}</label>
                </div>
              </div>
              <div class="mb-3" v-if="loginType === 'username'">
                <label for="username" class="form-label">{{ $t('login.username') }}</label>
                <input type="text" class="form-control" id="username" key="username" v-model="form.username" :class="{ 'is-invalid': $v.form.username.$dirty && $v.form.username.$error }">
                <div class="invalid-feedback">
                  {{ $t('message.requiredField') }}
                </div>
              </div>
              <div class="mb-3" v-else>
                <label for="phone" class="form-label">{{ $t('label.tel') }}</label>
                <input type="text" class="form-control" id="phone" key="phone" v-model="form.phone" v-mask="['(##) ####-####', '(##) #####-####']" :class="{ 'is-invalid': $v.form.phone.$dirty && $v.form.phone.$error }">
                <div class="invalid-feedback">
                  {{ $t('message.requiredField') }}
                </div>
              </div>
              <div class="mb-3">
                <label for="loginPass" class="form-label">{{ $t('login.password') }}</label>
                <input type="password" class="form-control" id="loginPass" v-model="form.password" :class="{ 'is-invalid': $v.form.password.$dirty && $v.form.password.$error }">
                <div class="invalid-feedback">
                  {{ $t('message.requiredField') }}
                </div>
              </div>
              <button type="submit" class="btn btn-primary btn-1-horus mt-4">{{$t('login.entrar')}}</button>
            </form>
          </div>
          <div class="col-md-6 ">
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import { required, requiredIf } from 'vuelidate/lib/validators'
export default {
  name: 'Login',
  data () {
    return {
      loginType: 'username',
      form: {
        username: '',
        phone: '',
        password: ''
      }
    }
  },
  validations: {
    form: {
      username: { required: requiredIf(parentVm => parentVm.loginType === 'username') },
      phone: { required: requiredIf(parentVm => parentVm.loginType === 'phone') },
      password: { required }
    }
  },
  methods: {
    submit () {
      this.$v.$touch()
      if (this.$v.form.$invalid) return
      if (this.loginType === 'phone' && this.form.phone && !this.form.phone.startsWith('55')) {
        this.form.phone = `55${this.form.phone}`
      }
      const request = this.loginType === 'phone'
        ? axios.post('/login/app', { login: this.form.phone, password: this.form.password })
        : axios.post('/login', { login: this.form.username, password: this.form.password })
      request.then(response => {
        if (response.data.token) {
          this.$store.commit('setUser', response.data)
          this.$router.push('/admin')
        }
      })
    }
  }
}
</script>
